import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiGetOutput = async (siId: string, modelId?: string) => {
  const params: IApiParams = {
    url:
      modelId === undefined
        ? `/output/getOutput.php?siId=${siId}`
        : `/output/getOutput.php?siId=${siId}&modelId=${modelId}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
